/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMarketingMessageRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {GetMarketingMessageResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const getMarketingMessage = (request: GetMarketingMessageRequest, options?: CashRequestOptions) => post<GetMarketingMessageRequest, GetMarketingMessageResponse>("/2.0/cash/get-marketing-message", request, {...options, rejectOnError: true })